import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import PlayIcon from 'assets/ver2/icons/play-icon.svg';
import { IS_PAYTO_CONFIG_DISABLE } from 'config';
import {
  ADD_TRANSACTION_PAYMENT_METHOD_NAME,
  DESKTOP_MIN_WIDTH,
  HHMT_ADD_TRANSACTION_PAYMENT_METHODS,
  LINK_REGISTRATION_HHMT_VIDEO_EMBED,
  LINK_REGISTRATION_REMOX_VIDEO_EMBED,
  METHOD_PAYTO,
  REMOX_ADD_TRANSACTION_PAYMENT_METHODS,
} from 'constants';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useAddTransaction from 'hooks/form-add-transaction/useAddTransaction';
import useCheckServiceAlerts from 'hooks/service-alerts/useCheckServiceAlerts';
import useServiceAlertsStore from 'hooks/service-alerts/useServiceAlertsStore';
import useCountryConfigUtils from 'hooks/useCountryConfigUtils';
import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import { isArray, isEmpty } from 'lodash';
import { Fragment } from 'react';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import PaymentMethodItem from '../PaymentMethodItem/ver2';

const PaymentMethodsGrid = ({
  countryConfig,
  information,
  setInformation,
  validation,
  setValidation,
  isSelectRequired,
}) => {
  const { t } = useLang();
  const { isHHMTTheme } = useTheme();

  const { payLimitConfig, getPayLimitRanger, isPaymentMethodDisabled } =
    useAddTransaction(countryConfig);

  const { serviceAlertsByPayments: serviceAlertsStore } =
    useServiceAlertsStore();
  const { checkByPaymentMethod } = useCheckServiceAlerts();
  const { checkServiceAlertsOfPaymentMethodItemDisable } =
    checkByPaymentMethod || {};

  const { paytoAccountsAgreement } = usePaytoStore();

  const { getPaymentOptionsConfig } = useCountryConfigUtils(countryConfig);

  const PAYMENT_METHODS = isHHMTTheme
    ? isEmpty(paytoAccountsAgreement)
      ? IS_PAYTO_CONFIG_DISABLE
        ? HHMT_ADD_TRANSACTION_PAYMENT_METHODS.slice(1)
        : HHMT_ADD_TRANSACTION_PAYMENT_METHODS
      : HHMT_ADD_TRANSACTION_PAYMENT_METHODS
    : isEmpty(paytoAccountsAgreement)
    ? IS_PAYTO_CONFIG_DISABLE
      ? REMOX_ADD_TRANSACTION_PAYMENT_METHODS.slice(1)
      : REMOX_ADD_TRANSACTION_PAYMENT_METHODS
    : REMOX_ADD_TRANSACTION_PAYMENT_METHODS;

  const handleHowToMakePayment = () => {
    window.open(
      isHHMTTheme
        ? t(LINK_REGISTRATION_HHMT_VIDEO_EMBED)
        : t(LINK_REGISTRATION_REMOX_VIDEO_EMBED)
    );
  };

  const checkPaymentMethodItemDisabled = (paymentMethod) => {
    if (paymentMethod === METHOD_PAYTO)
      return (
        (isArray(paytoAccountsAgreement) &&
          paytoAccountsAgreement?.some(
            (accountAgreement) => accountAgreement?.blocked
          )) ||
        (payLimitConfig && isPaymentMethodDisabled(paymentMethod)) ||
        checkServiceAlertsOfPaymentMethodItemDisable({
          serviceAlertsStore,
          paymentMethod,
        })
      );
    return (
      (payLimitConfig && isPaymentMethodDisabled(paymentMethod)) ||
      checkServiceAlertsOfPaymentMethodItemDisable({
        serviceAlertsStore,
        paymentMethod,
      })
    );
  };
  const renderPaymentMethodItem = (method) => {
    // if (isMobile || isTablet)
    //   return (
    //     <PaymentMethodItemMobile
    //       key={method.method}
    //       countryCode={countryConfig?.countryCode}
    //       method={method}
    //       information={information}
    //       setInformation={setInformation}
    //       validation={validation}
    //       setValidation={setValidation}
    //       payLimit={getPayLimitRanger(payLimitConfig)[method.method]}
    //       isDisabled={checkPaymentMethodItemDisabled(method.method)}
    //       isSelectRequired={isSelectRequired}
    //     />
    //   );

    return (
      <PaymentMethodItem
        key={method.method}
        countryCode={countryConfig?.countryCode}
        method={method}
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        payLimit={getPayLimitRanger(payLimitConfig)[method.method]}
        isDisabled={checkPaymentMethodItemDisabled(method.method)}
        isSelectRequired={isSelectRequired}
      />
    );
  };

  const renderNoticeSection = () => {
    return (
      <NoticeSection>
        <img src={NoticeIcon} width={50} height={41} />
        <p>{t('fx_add_transaction_pm_notice_desc')}</p>
      </NoticeSection>
    );
  };

  return (
    <>
      {renderNoticeSection()}
      <Label
        $isSelectRequired={validation[ADD_TRANSACTION_PAYMENT_METHOD_NAME]}
      >
        {t('add_transaction_title_payment_method_desc')}:
      </Label>
      <HowToMakePayment onClick={handleHowToMakePayment}>
        <img src={PlayIcon} alt="" />
        {t('button_how_to_make_payment')}
      </HowToMakePayment>
      <PaymentMethodsGridStyled>
        {PAYMENT_METHODS.map((method) => (
          <Fragment key={method.method}>
            {getPaymentOptionsConfig()?.[method.visible] && (
              <>{renderPaymentMethodItem(method)}</>
            )}
          </Fragment>
        ))}
      </PaymentMethodsGridStyled>
    </>
  );
};

const PaymentMethodsGridStyled = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 4px) calc(50% - 4px);
  flex-flow: wrap;
  grid-gap: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    display: flex;
    flex-flow: wrap;
    grid-gap: 24px;
  }
`;

const Label = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: ${(props) =>
    props.$isSelectRequired ? 'var(--ds-c-red)' : 'var(--ds-c-grey-dark)'};
  padding: 0;
  margin: 0;
  margin-bottom: 16px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const HowToMakePayment = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-blue-hyperlink-default);
  padding: 0;
  margin: 0;
  margin-bottom: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;

  & img {
    margin-right: 4px;
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;

    &:hover {
      color: var(--ds-c-blue-hover);

      & img {
        opacity: 0.5;
      }
    }
  }
`;

const NoticeSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--ds-c-yellow-light);
  border-radius: 8px;
  width: 100%;
  padding: 8px;
  margin-bottom: 20px;

  & p {
    ${paragraphMixin};
    font-size: 14px;
    line-height: 17px;
    font-weight: 500;
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 666px;
  }
`;

export default PaymentMethodsGrid;
